import React, { useEffect, useMemo, useState } from 'react';
import orderBy from 'lodash/orderBy';
import { useNavigate } from 'react-router-dom';

import {
  AFPTable,
  StatusBadge,
  Button,
  EmptyState,
} from '@gsa/afp-component-library';
import { useFvsPreBidContext } from '../../fvs-pre-bid-selection-provider';
import {
  PRE_BID_DOCUMENTATION_LABELS,
  DOCUMENT_REVIEW_STATUS,
} from '../constants';
/* eslint-disable react/prop-types */
const PsoReviewDocumentList = () => {
  const navigate = useNavigate();
  const { preBidDocumentationListForVendor } = useFvsPreBidContext();

  const [order, setOrder] = useState([['fvsId', 'ASC']]);

  const [tableData, setTableData] = useState([]);

  const handleSelectedRowClick = (evt, row) => {
    if (evt === 'document') {
      const { fvsId, contractYear } = row.original;
      const url = `/catalog/vehicle-standards/preview/${contractYear}/${fvsId}`;
      // TO-DO
      // set setFvsPreBidContextData('SET_MODAL_MODE', false); in order to close the modal
      navigate(url, { state: row.original });
    }
  };

  const mapStatusToBadgeColor = (reviewStatus) => {
    return reviewStatus === 1 ? 'Ready-Gray' : 'Warning-Gray';
  };

  /* eslint-disable-next-line */
  const columns = useMemo(() => {
    const columnList = [
      {
        Header: PRE_BID_DOCUMENTATION_LABELS.DOCUMENTS,
        accessor: 'fvsId',
        Cell: ({ row }) => {
          return (
            <Button
              variant="unstyled"
              data-testid="select-row"
              onClick={() => handleSelectedRowClick('document', row)}
              label={`${row?.original?.fedVehicleStandard?.fedStandardCode} - ${row?.original?.fedVehicleStandard?.fedStandard?.title}`}
            />
          );
        },
      },
      {
        Header: PRE_BID_DOCUMENTATION_LABELS.STATUS,
        accessor: 'reviewStatus',
        sortable: false,
        Cell: ({ value }) => {
          return (
            <StatusBadge variant={mapStatusToBadgeColor(value)}>
              {value === 1
                ? DOCUMENT_REVIEW_STATUS.REVIEW_DONE
                : DOCUMENT_REVIEW_STATUS.NEEDS_REVIEW}
            </StatusBadge>
          );
        },
      },
    ];

    return columnList;
  }, []);

  useEffect(() => {
    if (
      preBidDocumentationListForVendor &&
      preBidDocumentationListForVendor?.preBidReviewDocuments
    ) {
      setTableData(
        orderBy(
          preBidDocumentationListForVendor?.preBidReviewDocuments,
          'fvsId',
          'ASC',
        ),
      );
    }
  }, []);

  const onSort = (newOrder) => {
    // requires asc/desc to be lowercase for lodash orderBy function
    setTableData(
      orderBy(
        [...(tableData ?? [])],
        newOrder[0]?.[0] ?? '',
        newOrder[0]?.[1]?.toLowerCase() ?? 'asc',
      ),
    );
    setOrder(newOrder);
  };

  return (
    <>
      {tableData && tableData.length > 0 ? (
        <AFPTable
          fullWidth
          testId="pso-review-doc-list"
          columns={columns}
          data={tableData}
          onSort={onSort}
          defaultSort={order}
        />
      ) : (
        <EmptyState
          hasBackground
          containerStyles="padding-y-8 margin-top-1"
          topText={<strong>There is no document to review.</strong>}
        />
      )}
    </>
  );
};

export default PsoReviewDocumentList;
